"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _platform = require("../../../../../helpers/platform");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
var ModalContent = function ModalContent(_ref) {
  var isLandscape = _ref.isLandscape,
    imageWebp = _ref.imageWebp,
    image = _ref.image,
    alt = _ref.alt;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Wrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("picture", {
      children: isLandscape ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          srcSet: imageWebp,
          type: "image/webp",
          media: _platform.isMsite ? 'width:100%' : 'width:70vw'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          srcSet: image,
          type: "image/jpeg",
          media: _platform.isMsite ? 'width:100%' : 'width:70vw'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: image,
          alt: alt,
          style: _platform.isMsite ? {
            width: '100%',
            height: '100%'
          } : {
            width: '70vw',
            height: '100%'
          }
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          srcSet: imageWebp,
          type: "image/webp",
          media: "(height:70vh)",
          style: {
            maxWidth: 'auto',
            height: '70vh'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
          srcSet: image,
          type: "image/jpeg",
          media: "(height:70vh)",
          style: {
            maxWidth: 'auto',
            height: '70vh'
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: image,
          alt: alt,
          style: {
            maxWidth: 'auto',
            mhight: '70vh'
          }
        })]
      })
    })
  });
};
var _default = exports["default"] = ModalContent;